var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1502.96 991.06",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-15);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-3 {\n        fill: #f99662;\n      }\n\n      .cls-4 {\n        fill: #f26e5a;\n        mix-blend-mode: multiply;\n        opacity: .4;\n      }\n\n      .cls-5 {\n        fill: #dfeaef;\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-9 {\n        fill: #fff;\n      }\n\n      .cls-10 {\n        opacity: .25;\n      }\n\n      .cls-11 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-12 {\n        fill: #3a4351;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient-22);\n      }\n\n      .cls-16 {\n        isolation: isolate;\n      }\n\n      .cls-17 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-18 {\n        opacity: .15;\n      }\n\n      .cls-19 {\n        fill: #c5cdd8;\n      }\n\n      .cls-20 {\n        fill: url(#linear-gradient-14);\n      }\n\n      .cls-21 {\n        fill: url(#linear-gradient-20);\n      }\n\n      .cls-22 {\n        fill: url(#linear-gradient-17);\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-24 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-25 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-26 {\n        fill: url(#linear-gradient-19);\n      }\n\n      .cls-27 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-28 {\n        fill: #dadaea;\n      }\n\n      .cls-29 {\n        fill: #0562e8;\n      }\n\n      .cls-30 {\n        fill: url(#linear-gradient-21);\n      }\n\n      .cls-31 {\n        fill: url(#linear-gradient-16);\n      }\n\n      .cls-32 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-33 {\n        fill: url(#linear-gradient-23);\n      }\n\n      .cls-34 {\n        fill: #dfe8f7;\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-18);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 3365.1,
    y1: 363.88,
    x2: 2940.98,
    y2: 363.88,
    gradientTransform: "translate(4264.19 729.26) rotate(-179.97)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ebf2fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84adef"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 13271.09,
    y1: 432.48,
    x2: 13738.51,
    y2: 432.48,
    gradientTransform: "translate(-12429.01 824.97) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 13295.6,
    y1: 461.11,
    x2: 13682.97,
    y2: 461.11,
    gradientTransform: "translate(-12491.65 882.26) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 13312.5,
    y1: 432.48,
    x2: 13722.58,
    y2: 432.48,
    gradientTransform: "translate(-12690.07 825.03) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 4027.26,
    y1: 980.67,
    x2: 3162.52,
    y2: 980.67,
    gradientTransform: "translate(4510.28 1789.69) rotate(-174.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 13271.61,
    y1: 544.21,
    x2: 13739.04,
    y2: 544.21,
    gradientTransform: "translate(-12430.01 1048.44) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 13296.13,
    y1: 572.84,
    x2: 13683.5,
    y2: 572.84,
    gradientTransform: "translate(-12492.66 1105.73) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 13313.02,
    y1: 544.21,
    x2: 13723.11,
    y2: 544.21,
    gradientTransform: "translate(-12691.08 1048.5) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 3365.1,
    y1: 646.65,
    x2: 2940.98,
    y2: 646.65,
    gradientTransform: "translate(4264.06 1294.81) rotate(-179.97)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: 13271.22,
    y1: 715.25,
    x2: 13738.64,
    y2: 715.25,
    gradientTransform: "translate(-12429.14 1390.52) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 13295.73,
    y1: 743.88,
    x2: 13683.11,
    y2: 743.88,
    gradientTransform: "translate(-12491.78 1447.8) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: 13312.63,
    y1: 715.25,
    x2: 13722.71,
    y2: 715.25,
    gradientTransform: "translate(-12690.21 1390.58) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 4053.61,
    y1: 1262.21,
    x2: 3188.88,
    y2: 1262.21,
    gradientTransform: "translate(4510.15 2355.24) rotate(-174.63)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 13271.75,
    y1: 826.98,
    x2: 13739.17,
    y2: 826.98,
    gradientTransform: "translate(-12430.14 1613.99) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-15",
    x1: 13296.26,
    y1: 855.62,
    x2: 13683.63,
    y2: 855.62,
    gradientTransform: "translate(-12492.79 1671.27) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-16",
    x1: 13313.15,
    y1: 826.98,
    x2: 13723.24,
    y2: 826.98,
    gradientTransform: "translate(-12691.21 1614.05) scale(1 -1)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-17",
    x1: 1012.43,
    y1: 260.74,
    x2: 1127.62,
    y2: 260.74,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#22e673"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22c673"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-18",
    x1: 1141.57,
    x2: 1256.76,
    xlinkHref: "#linear-gradient-17"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-19",
    x1: 833.82,
    y1: 581.91,
    x2: 955.91,
    y2: 581.91,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#05a1e8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0562e8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-20",
    x1: 576.61,
    y1: 671.67,
    x2: 919.17,
    y2: 671.67,
    xlinkHref: "#linear-gradient-19"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-21",
    x1: 812.36,
    y1: 680.46,
    x2: 1027.64,
    y2: 680.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#db1162"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff6817"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-22",
    x1: 760.04,
    y1: 764.94,
    x2: 1074.5,
    y2: 450.48,
    xlinkHref: "#linear-gradient-21"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-23",
    x1: 523,
    y1: 553.82,
    x2: 648.23,
    y2: 553.82,
    xlinkHref: "#linear-gradient-19"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-16"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M470.07,897.48h-64.39c0-.1.01-.2,0-.29-2.08-12.29-4.17-24.57-6.22-36.86-.14-.82-.58-1.1-1.29-1.3-9.92-2.68-19.32-6.67-28.37-11.48-.89-.47-1.44-.35-2.19.19-7.49,5.37-15.01,10.7-22.53,16.05-3.04,2.16-6.08,4.32-8.93,6.34-15.13-15.11-30.16-30.12-45.24-45.18.24-.35.54-.8.84-1.23,7.17-10.09,14.33-20.18,21.53-30.24.58-.81.67-1.4.17-2.33-4.76-8.81-8.79-17.92-11.51-27.59-.14-.5-.8-1.12-1.3-1.2-5.82-1.04-11.66-1.99-17.5-2.97-6.93-1.16-13.87-2.33-20.8-3.5,0-21.37,0-42.73,0-64.1,4.66-.68,9.31-1.37,13.97-2.05,8.06-1.18,16.12-2.37,24.19-3.55.78-.11,1.26-.38,1.5-1.25,2.69-9.87,6.6-19.25,11.41-28.26.5-.95.49-1.58-.15-2.45-4.43-6.02-8.81-12.07-13.21-18.12-3.08-4.23-6.15-8.47-9.29-12.79,15.34-15.09,30.62-30.12,45.88-45.14.66.46,1.14.79,1.61,1.12,9.8,6.9,19.6,13.8,29.38,20.73.78.56,1.35.61,2.2.15,8.85-4.78,18-8.85,27.73-11.55.46-.13,1.03-.74,1.11-1.2,1.42-8.17,2.76-16.36,4.13-24.54.77-4.59,1.54-9.17,2.32-13.79h64.04c.11.46.24.88.31,1.31,2.05,12.05,4.1,24.1,6.12,36.15.13.79.4,1.16,1.17,1.39,9.71,2.87,18.96,6.82,27.89,11.57.75.4,1.25.36,1.94-.12,5.81-4.05,11.65-8.06,17.49-12.08,4.75-3.27,9.5-6.55,14.35-9.88,15.09,15.33,30.12,30.61,45.15,45.89-.54.75-.96,1.34-1.38,1.93-7.02,9.66-14.04,19.31-21.06,28.97-.44.61-.95,1.1-.4,2.04,5.11,8.87,8.97,18.26,11.71,28.12.11.41.7.91,1.14.99,9.94,1.7,19.9,3.34,29.85,5,2.85.48,5.69.97,8.48,1.45v64.12c-4.44.67-8.8,1.33-13.17,1.99-8.01,1.21-16.02,2.41-24.03,3.61-.79.12-1.38.28-1.65,1.26-2.61,9.7-6.69,18.8-11.44,27.62-.46.86-.47,1.47.13,2.31,5.44,7.57,10.82,15.17,16.22,22.77,2.1,2.96,4.21,5.92,6.15,8.65-15.14,15.15-30.15,30.18-45.2,45.25-.33-.23-.77-.54-1.2-.85-10.09-7.17-20.18-14.33-30.25-21.52-.77-.55-1.33-.66-2.2-.2-8.66,4.62-17.64,8.5-27.06,11.29-1.31.39-1.82.99-2.03,2.34-1.04,6.71-2.21,13.4-3.32,20.1-.93,5.64-1.84,11.29-2.76,16.94ZM437.18,810.91c48.14,0,86.96-38.76,87.02-86.88.06-47.88-39.26-87.26-87.1-87.23-47.62.03-87.01,39.29-87.02,86.74-.01,48.58,38.66,87.37,87.1,87.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M485.19,439.53h-46.84c0-.07.01-.14,0-.21-1.51-8.94-3.03-17.87-4.53-26.81-.1-.6-.42-.8-.94-.94-7.22-1.95-14.05-4.85-20.64-8.35-.65-.34-1.05-.26-1.59.14-5.45,3.9-10.92,7.78-16.38,11.67-2.21,1.57-4.42,3.14-6.5,4.61-11.01-10.99-21.94-21.91-32.91-32.87.18-.26.39-.58.61-.89,5.21-7.34,10.42-14.68,15.66-22,.42-.59.49-1.02.12-1.69-3.46-6.41-6.39-13.04-8.38-20.07-.1-.36-.58-.81-.94-.88-4.24-.76-8.48-1.45-12.73-2.16-5.04-.85-10.09-1.7-15.13-2.55,0-15.54,0-31.08,0-46.62,3.39-.5,6.77-.99,10.16-1.49,5.86-.86,11.73-1.73,17.59-2.58.57-.08.92-.28,1.09-.91,1.96-7.18,4.8-14,8.3-20.55.37-.69.36-1.15-.11-1.78-3.23-4.38-6.41-8.78-9.61-13.18-2.24-3.08-4.47-6.16-6.76-9.31,11.16-10.98,22.27-21.91,33.37-32.84.48.33.83.57,1.17.82,7.13,5.02,14.26,10.04,21.37,15.08.57.4.98.44,1.6.11,6.44-3.48,13.09-6.44,20.17-8.4.33-.09.75-.54.81-.88,1.03-5.94,2.01-11.9,3-17.85.56-3.34,1.12-6.67,1.69-10.03h46.58c.08.34.17.64.22.95,1.49,8.76,2.99,17.53,4.45,26.3.1.57.29.85.85,1.01,7.06,2.09,13.79,4.96,20.29,8.42.54.29.91.26,1.41-.09,4.23-2.94,8.48-5.86,12.72-8.78,3.46-2.38,6.91-4.76,10.44-7.19,10.97,11.15,21.91,22.26,32.84,33.38-.39.54-.7.98-1.01,1.4-5.11,7.02-10.22,14.05-15.32,21.07-.32.44-.69.8-.29,1.49,3.72,6.45,6.52,13.28,8.52,20.45.08.3.51.66.83.72,7.23,1.24,14.47,2.43,21.71,3.64,2.07.35,4.14.71,6.17,1.05v46.64c-3.23.49-6.4.97-9.58,1.45-5.83.88-11.65,1.75-17.48,2.62-.58.09-1.01.2-1.2.92-1.9,7.05-4.86,13.68-8.32,20.09-.34.63-.34,1.07.1,1.68,3.96,5.5,7.87,11.04,11.8,16.56,1.53,2.15,3.06,4.31,4.47,6.29-11.01,11.02-21.93,21.95-32.88,32.91-.24-.17-.56-.39-.88-.61-7.34-5.21-14.68-10.42-22-15.66-.56-.4-.97-.48-1.6-.14-6.3,3.36-12.83,6.18-19.68,8.21-.95.28-1.32.72-1.47,1.7-.75,4.88-1.61,9.75-2.41,14.62-.68,4.11-1.34,8.22-2.01,12.32ZM461.27,376.56c35.02,0,63.25-28.19,63.3-63.19.04-34.82-28.56-63.47-63.36-63.45-34.63.02-63.29,28.58-63.29,63.09,0,35.33,28.12,63.55,63.35,63.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M337.02,543.37h-23.15s0-.07,0-.1c-.75-4.42-1.5-8.84-2.24-13.25-.05-.29-.21-.4-.47-.47-3.57-.97-6.95-2.4-10.2-4.13-.32-.17-.52-.13-.79.07-2.69,1.93-5.4,3.85-8.1,5.77-1.09.78-2.19,1.55-3.21,2.28-5.44-5.43-10.85-10.83-16.27-16.25.09-.13.19-.29.3-.44,2.58-3.63,5.15-7.25,7.74-10.87.21-.29.24-.51.06-.84-1.71-3.17-3.16-6.44-4.14-9.92-.05-.18-.29-.4-.47-.43-2.09-.37-4.19-.72-6.29-1.07-2.49-.42-4.99-.84-7.48-1.26,0-7.68,0-15.36,0-23.05,1.67-.25,3.35-.49,5.02-.74,2.9-.43,5.8-.85,8.7-1.28.28-.04.45-.14.54-.45.97-3.55,2.37-6.92,4.1-10.16.18-.34.18-.57-.05-.88-1.59-2.16-3.17-4.34-4.75-6.52-1.11-1.52-2.21-3.04-3.34-4.6,5.52-5.43,11.01-10.83,16.5-16.23.24.16.41.28.58.4,3.52,2.48,7.05,4.96,10.56,7.45.28.2.48.22.79.05,3.18-1.72,6.47-3.18,9.97-4.15.17-.05.37-.27.4-.43.51-2.94.99-5.88,1.48-8.82.28-1.65.55-3.3.83-4.96h23.03c.04.17.08.32.11.47.74,4.33,1.48,8.66,2.2,13,.05.28.14.42.42.5,3.49,1.03,6.82,2.45,10.03,4.16.27.14.45.13.7-.04,2.09-1.46,4.19-2.9,6.29-4.34,1.71-1.18,3.42-2.35,5.16-3.55,5.43,5.51,10.83,11.01,16.24,16.5-.19.27-.34.48-.5.69-2.52,3.47-5.05,6.94-7.57,10.42-.16.22-.34.4-.14.73,1.84,3.19,3.22,6.57,4.21,10.11.04.15.25.33.41.35,3.58.61,7.15,1.2,10.73,1.8,1.02.17,2.05.35,3.05.52v23.05c-1.6.24-3.17.48-4.73.72-2.88.43-5.76.87-8.64,1.3-.29.04-.5.1-.59.45-.94,3.49-2.4,6.76-4.11,9.93-.17.31-.17.53.05.83,1.96,2.72,3.89,5.46,5.83,8.19.76,1.06,1.51,2.13,2.21,3.11-5.44,5.45-10.84,10.85-16.25,16.27-.12-.08-.28-.19-.43-.3-3.63-2.58-7.26-5.15-10.88-7.74-.28-.2-.48-.24-.79-.07-3.11,1.66-6.34,3.06-9.73,4.06-.47.14-.65.35-.73.84-.37,2.41-.79,4.82-1.19,7.23-.34,2.03-.66,4.06-.99,6.09ZM325.19,512.24c17.31,0,31.27-13.94,31.29-31.24.02-17.21-14.12-31.37-31.32-31.36-17.12,0-31.28,14.13-31.29,31.19,0,17.47,13.9,31.41,31.32,31.41Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1141.97,
    y: 354.27,
    width: 76.33,
    height: 76.33,
    rx: 2.85,
    ry: 2.85,
    transform: "translate(2360.45 784.33) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1141.96,362.06l.03,60.79c0,4.28,3.45,7.76,7.77,7.76l60.79-.03c1.52,0,2.92-.42,4.13-1.18l-71.54-71.47c-.76,1.21-1.17,2.61-1.17,4.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 912,
    y: 354.27,
    width: 201.82,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2025.99 727.29) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 985.21,
    y: 382.89,
    width: 128.62,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2099.23 784.51) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 922.57,
    y: 411.54,
    width: 191.28,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2036.61 841.82) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 865.83,
    y: 382.95,
    width: 106.33,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(1838.16 784.69) rotate(179.97)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1141.5,
    y: 466.01,
    width: 76.33,
    height: 76.33,
    rx: 2.85,
    ry: 2.85,
    transform: "translate(2359.55 1007.8) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1141.48,473.8l.03,60.79c0,4.28,3.45,7.76,7.77,7.76l60.79-.03c1.52,0,2.92-.42,4.13-1.18l-71.54-71.47c-.76,1.21-1.17,2.61-1.17,4.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 911.52,
    y: 466.01,
    width: 201.82,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2025.09 950.76) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 984.74,
    y: 494.63,
    width: 128.62,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2098.33 1007.98) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 922.09,
    y: 523.28,
    width: 191.28,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2035.71 1065.29) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 865.35,
    y: 494.69,
    width: 106.33,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(1837.26 1008.16) rotate(179.97)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 1141.97,
    y: 637.05,
    width: 76.33,
    height: 76.33,
    rx: 2.85,
    ry: 2.85,
    transform: "translate(2360.58 1349.88) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M1141.96,644.84l.03,60.79c0,4.28,3.45,7.76,7.77,7.76l60.79-.03c1.52,0,2.92-.42,4.13-1.18l-71.54-71.47c-.76,1.21-1.17,2.61-1.17,4.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 912,
    y: 637.05,
    width: 201.82,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2026.12 1292.84) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 985.21,
    y: 665.67,
    width: 128.62,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2099.36 1350.06) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 922.57,
    y: 694.31,
    width: 191.28,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2036.74 1407.37) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 865.83,
    y: 665.73,
    width: 106.33,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(1838.29 1350.24) rotate(179.97)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 1141.5,
    y: 748.78,
    width: 76.33,
    height: 76.33,
    rx: 2.85,
    ry: 2.85,
    transform: "translate(2359.68 1573.34) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M1141.48,756.57l.03,60.79c0,4.28,3.45,7.76,7.77,7.76l60.79-.03c1.52,0,2.92-.42,4.13-1.18l-71.54-71.47c-.76,1.21-1.17,2.61-1.17,4.13Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 911.52,
    y: 748.78,
    width: 201.82,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2025.22 1516.3) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 984.74,
    y: 777.4,
    width: 128.62,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2098.46 1573.52) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 922.09,
    y: 806.05,
    width: 191.28,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(2035.84 1630.84) rotate(179.97)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 865.35,
    y: 777.46,
    width: 106.33,
    height: 19.21,
    rx: 3.52,
    ry: 3.52,
    transform: "translate(1837.39 1573.7) rotate(179.97)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "1012.43 204 1127.62 252.72 1012.43 317.48 1060.76 257.85 1012.43 204"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "1141.57 204 1256.76 252.72 1141.57 317.48 1189.9 257.85 1141.57 204"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "852.29 491.29 955.91 627.99 833.82 672.53 852.29 491.29"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M582.57,447.14c15.75-15.75,52.4-27.31,76.29-33.51,13.73-3.56,28-4.38,42.06-2.47l53.77,7.29s69.85,44.9,96.04,71.09c26.19,26.19,49.89,190.21,49.89,190.21l-11.87,62.5,30.42,180.15c-6.01,0-222.05,26.48-322.24-3.58,0,0,18.92-56.18,16.16-145.31-11.77-67.69-51.36-305.53-30.52-326.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M583.67,446.08c8.25-7.7,20.97-13.9,31.37-18.21,0,0,.01.02.01.02,0,0,19.85-10.89,37.87,63.4,18.02,74.29-4.86,164.67,3.12,172.66,7.99,7.99,183.43-1.06,183.43-1.06,0,0-102.51,58.92-152.54,101.87-20.06,17.22-73.27,26.27-73.37,25.71-.15-5.83-.31-11.5-.48-16.95-5.68-32.68-53.56-304.91-29.42-327.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M1026.29,602.61l-88.1,166.46c-2.07,3.91-6.19,6.25-10.57,5.99l-104.66-6.17c-7.5-.44-12.47-8.07-9.93-15.23l53.98-151.96c1.52-4.29,5.43-7.25,9.92-7.52l138.78-8.33c8.78-.53,14.74,8.9,10.58,16.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M804.75,752.82l54.66-150.54c1.54-4.25,5.49-7.18,10.05-7.45l5.42-.32c-3.15,1.13-5.71,3.62-6.88,6.87l-54.66,151.96c-2.35,6.53,1.64,13.45,8.12,14.95l-6.65-.38c-7.6-.44-12.63-7.99-10.06-15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M804.75,752.82l54.66-150.54c1.54-4.25,5.49-7.18,10.05-7.45l5.42-.32c-3.15,1.13-5.71,3.62-6.88,6.87l-54.66,151.96c-2.35,6.53,1.64,13.45,8.12,14.95l-6.65-.38c-7.6-.44-12.63-7.99-10.06-15.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M607.51,649.61l8.32,29.91s177.11-45.7,197.9-55.68c16.82-8.07,83.67-25.95,108.56-24.22,4.05.28,4.58,6,.63,6.95-15.67,3.77-46.83,11.66-46.83,14.77,0,4.16,31.37,10.28,29.1,15.38-4.57,10.29-19.96,16.21-22.87,25.78-2.91,9.56-34.75,2.08-45.65,2.08s-212.95,122.65-274.07,93.55c-61.12-29.1-24.11-158.19-24.11-158.19l69.02,49.68Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M939.63,713.64c4.05-4.05,3.85-14.03,8.52-18.71,4.68-4.68,9.77,4.78,11.02-5.82,1.25-10.6-6.24-27.02,1.04-26.19,7.28.83,17.26,30.77,17.26,30.77,5.24,12.21-18.29,57.79-30.75,54.68-12.45-3.11-17.27-17.89-17.27-24.75s6.13-5.92,10.19-9.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M782.9,375.91c-4.2,22.08-6.18,45.88-2.4,59.72,0,0-8.72,37.77-30.47,39.61-21.75,1.84-62.96-65.02-62.96-65.02l45.25-71.17,50.58,36.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M778.63,410.57c-26.1-4.57-50.54-24.54-57.32-54.19l11.02-17.33,50.58,36.87c-2.21,11.64-3.81,23.77-4.27,34.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M829.24,242.3s21.31,133.7-16.81,149.12c-38.13,15.43-89.66-9.32-93.49-54.68-3.83-45.36,5.87-137.87,110.31-94.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M790.62,214.89s72.66-21.47,76.96-.24c4.3,21.23-19.63,37.02-36.3,38.43-16.66,1.41-59.25-.78-72.19,14.55-12.94,15.33-36.12,86.19-36.12,86.19l-13.08,20.52s-5.33-37.33-24.16-60.14c-18.83-22.82-8.25-62.1,9.82-88.97,18.07-26.87,78.6-8.93,95.07-10.33Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M744.29,304.6s-6.91-18.73-17.16-16.07c-23.25,6.04-6.19,47.42,1.45,48.55,15.52,2.3,21.8-9.95,15.71-32.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M648.21,504.53c.77,44.36-23.24,175.22-23.24,175.22,0,0-93.13-1.87-100.61-9.35-7.48-7.48,16.5-204.97,57.63-232.64,49.12-33.05,65.48,23.97,66.22,66.77Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M742.45,300.48c1.21,15.67,6.46,34.55,4.14,47.16-2.32,12.61-4.42,19.15-6.76,22.18-2.34,3.04-5.14,8.17-3.74,11.44,1.4,3.27,10.27,24.47,42.03,25.9,31.76,1.42,63.28-10.25,64.91-47.61,0-18.91-.47-19.61-12.38-18.45-11.91,1.17-42.5,8.17-56.74,4.67-14.24-3.5-19.42-56.96-16.13-76.47,0,0-17.17,7.61-15.35,31.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M802.18,364.22c0,4.77,3.87,8.64,8.64,8.64s8.64-3.87,8.64-8.64"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M786.24,284.5c11.78-7.74,39.93.04,40.65-9.23.72-9.27-29.07-3.58-40.65,9.23"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingDevelopment);
export default __webpack_public_path__ + "static/media/training-development.2d0cc83fd8b6603ed5a34dd866a8df73.svg";
export { ForwardRef as ReactComponent };